/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { useQuery } from "@tanstack/react-query";
import { getAllStorageLocations, getStorageLocationDetails } from "./storageLocationFunctions";

export function useStorageLocationDetails(storageLocationId: number) {
    return useQuery({
        queryKey: ["STORAGE_LOCATION", "DETAILS", storageLocationId],
        queryFn: () => getStorageLocationDetails(storageLocationId),
        select: ({ data }) => data,
    });
}

export function useAllStorageLocations() {
    return useQuery({
        queryKey: ["STORAGE_LOCATION", "LIST-ALL"],
        queryFn: () => getAllStorageLocations(),
        select: ({ data }) => data,
    });
}
